/** A rejoin hint only: it cannot authorize membership or suppress repair of an unhealthy peer. */
export interface PeerContinuity {
  retainedPeerIds: string[];
}
export function readPeerContinuity(value: unknown): PeerContinuity {
  const ids = (value as Partial<PeerContinuity> | null)?.retainedPeerIds;
  return {
    retainedPeerIds:
      Array.isArray(ids) && ids.length <= 64
        ? [
            ...new Set(
              ids.filter(
                (id): id is string => typeof id === 'string' && id.length > 0 && id.length <= 100
              )
            ),
          ]
        : [],
  };
}
export function isRetainedPeerHealthy(
  peer:
    | {
        destroyed?: boolean;
        connected?: boolean;
        _pc?: { connectionState?: string };
      }
    | null
    | undefined
): boolean {
  return (
    !!peer &&
    !peer.destroyed &&
    peer.connected === true &&
    peer._pc?.connectionState === 'connected'
  );
}

export const PEER_REPAIR_REQUEST = 'peer:repair-request';
export const PEER_REPAIR = 'peer:repair';
